import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#8e24aa", // purple
    },
    secondary: {
      main: "#fbc02d", // gold
    },
    background: {
      default: "#f8f5f0",
    },
  },
  typography: {
    fontFamily: "Poppins, Roboto, sans-serif",
    h2: {
      fontWeight: 700,
    },
    h4: {
      fontWeight: 600,
    },
  },
});

export default theme;